import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { MessageEntity } from './message.entity';

@Index('_fk__cron__id', ['fkCronId'], {})
@Index('_ix_identifier', ['identifier', 'state'], {})
// PD-17593 — the legacy server polls this table every minute by state: it
// resets RUNNING jobs past their time limit to PENDING and picks the PENDING
// jobs that are due (`_next_run_time`). `_ix_identifier` leads with the
// identifier, so both polls read the whole table — 1.17M rows on
// pharmsource_prod, almost all COMPLETED — to find a few thousand RUNNING and
// a handful of PENDING rows. State first, then the due time it ranges on.
@Index('_ix_state_next_run_time', ['state', 'nextRunTime'], {})
@Entity('_cron')
export class CronEntity extends BaseEntity {
	@Column('varchar', { name: '_action', nullable: true, length: 45 })
	public action!: string | null;

	@Column('int', { name: '_fk__cron__id', nullable: true, unsigned: true })
	public fkCronId!: number | null;

	@Column('varchar', { name: '_identifier', nullable: true, length: 128 })
	public identifier!: string | null;

	@Column('text', { name: '_last_message', nullable: true })
	public lastMessage!: string | null;

	@Column('int', {
		name: '_max_retries',
		nullable: true,
		unsigned: true,
		default: () => "'0'",
	})
	public maxRetries!: number | null;

	@Column('varchar', { name: '_name', nullable: true, length: 128 })
	public name!: string | null;

	@Column('datetime', { name: '_next_run_time', nullable: true })
	public nextRunTime!: Date | null;

	@Column('longtext', { name: '_params', nullable: true })
	public params!: string | null;

	@Column('int', {
		name: '_retry_count',
		nullable: true,
		unsigned: true,
		default: () => "'0'",
	})
	public retryCount!: number | null;

	@Column('varchar', { name: '_schedule', nullable: true, length: 255 })
	public schedule!: string | null;

	@Column('varchar', { name: '_sqs_queue_url', nullable: true, length: 255 })
	public sqsQueueUrl!: string | null;

	@Column('varchar', {
		name: '_state',
		nullable: true,
		length: 16,
		default: () => "'PENDING'",
	})
	public state!: string | null;

	@Column('varchar', { name: '_timezone', nullable: true, length: 45 })
	public timezone!: string | null;

	@Column('int', { name: '_runningTimeLimit', nullable: true, unsigned: true })
	public runningTimeLimit!: number | null;

	@ManyToOne(() => CronEntity, (cron) => cron.crons, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__cron__id', referencedColumnName: 'id' }])
	public fkCron!: CronEntity;

	@OneToMany(() => CronEntity, (cron) => cron.fkCron, {})
	public crons!: Array<CronEntity>;

	@OneToMany(() => MessageEntity, (message) => message.fkCron, {})
	public messages!: Array<MessageEntity>;
}
